import axios from "@/plugins/customAxios";
import { ModpackInterface } from "@/types";
import moment from "moment";

export default class ModpackService {
  public static async getModpacks (): Promise<ModpackInterface[]> {
    const halfAYearAgo = moment(new Date()).add(-6, "months").toISOString().substring(0, 10);
    const response = await axios.get("/arma/modpacks", {
      params: {
        "sort[desc]": "lastUsed",
        "lastUsed[gte]": halfAYearAgo,
      },
    });
    return response.data;
  }

  public static async uploadModpack(modpack: File): Promise<ModpackInterface> {
    const formData = new FormData();
    formData.append("File", modpack);
    const response = await axios.post("/arma/modpacks", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    return response.data;
  }
}
